import { useState } from "react";
import {
  FiCheck,
  FiHome,
  FiShield,
  FiCoffee,
  FiSun,
  FiDroplet
} from "react-icons/fi";

function HotelEquipments({ equipments }) {
  const [showAll, setShowAll] = useState(false);

  const MAX_TOTAL = 12;

  const visibleEquipments = showAll
    ? equipments
    : equipments.slice(0, MAX_TOTAL);

  const categories = {
    "Salle de bain": ["douche", "serviettes", "toilettes", "papier"],
    "Confort": ["climatisation", "insonorisées", "familiales"],
    "Sécurité": ["extincteurs", "caméras", "détecteurs", "alarme", "coffre"],
    "Extérieur": ["mer", "terrasse", "extérieur"],
    "Services": ["réception", "concierge", "bagagerie", "restaurant", "voiture"]
  };

  const categoryIcons = {
    "Salle de bain": <FiDroplet />,
    "Confort": <FiHome />,
    "Sécurité": <FiShield />,
    "Extérieur": <FiSun />,
    "Services": <FiCoffee />,
    "Autres": <FiCheck />
  };

  const getCategory = (item) => {
    const lower = item.toLowerCase();
    for (const [cat, list] of Object.entries(categories)) {
      if (list.some(e => lower.includes(e))) return cat;
    }
    return "Autres";
  };

  const grouped = {};
  visibleEquipments.forEach(item => {
    const cat = getCategory(item);
    if (!grouped[cat]) grouped[cat] = [];
    grouped[cat].push(item);
  });

  // ✅ TRI : "Autres" toujours en dernier
  const sortedGroupedEntries = Object.entries(grouped).sort(([a], [b]) => {
    if (a === "Autres") return 1;
    if (b === "Autres") return -1;
    return 0;
  });

  return (
    <div className="mt-20 px-4 md:px-0" id="equipements">

      <div className="bg-white rounded-3xl border border-gray-100 shadow-sm p-6 md:p-10">

        {/* HEADER */}
        <div className="mb-10">
          <h2 className="text-2xl md:text-3xl font-semibold text-gray-900">
            Équipements
          </h2>
          <p className="text-sm text-gray-500 mt-2">
            Profitez de tous les services et équipements proposés par cet établissement
          </p>
        </div>

        {/* GRID */}
        <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-10">

          {sortedGroupedEntries.map(([category, items], i) => (
            <div key={i} className="group">

              {/* CATEGORY HEADER */}
              <div className="flex items-center gap-3 mb-4">

                <div className="
                  w-9 h-9 rounded-xl
                  bg-[#3A9D23]/10
                  text-[#3A9D23]
                  flex items-center justify-center
                  text-lg
                ">
                  {categoryIcons[category] || <FiCheck />}
                </div>

                <h3 className="text-base font-semibold text-gray-900">
                  {category}
                </h3>

              </div>

              {/* ITEMS */}
              <div className="flex flex-col gap-3">

                {items.map((item, index) => (
                  <div
                    key={index}
                    className="
                      flex items-center gap-3
                      text-sm text-gray-700
                      transition
                      group-hover:translate-x-[2px]
                    "
                  >
                    <div className="
                      w-5 h-5 rounded-full
                      bg-gray-100
                      flex items-center justify-center
                      text-gray-500
                      shrink-0
                    ">
                      <FiCheck size={12} />
                    </div>

                    <span className="leading-snug">
                      {item}
                    </span>

                  </div>
                ))}

              </div>

            </div>
          ))}

        </div>

        {/* CTA */}
        {equipments.length > MAX_TOTAL && (
          <div className="mt-12 text-center">

            <button
              onClick={() => setShowAll(!showAll)}
              className="
                text-sm font-medium text-gray-800
                px-6 py-3 rounded-xl
                border border-gray-200
                hover:bg-gray-50 hover:border-gray-300
                hover:shadow-sm
                transition
              "
            >
              {showAll
                ? "Réduire"
                : `Voir tous les équipements (${equipments.length})`}
            </button>

          </div>
        )}

      </div>
    </div>
  );
}

export default HotelEquipments;